import { useState, useEffect } from 'react'
import { LOCAL_STORAGE_VALUES } from '../localStorage'

export const useDevMode = () => {
  const [isDevMode, setIsDevMode] = useState(false)

  const updateDevMode = () => {
    const devModeValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_VALUES.devMode)) || false
    setIsDevMode(devModeValue)
  }

  useEffect(() => {
    updateDevMode()
  }, [])

  const enableDevMode = () => {
    localStorage.setItem(LOCAL_STORAGE_VALUES.devMode, JSON.stringify(true))
    setIsDevMode(true)
  }

  const disableDevMode = () => {
    localStorage.setItem(LOCAL_STORAGE_VALUES.devMode, JSON.stringify(false))
    setIsDevMode(false)
  }

  const toggleDevMode = () => {
    if (isDevMode) {
      disableDevMode()
    } else {
      enableDevMode()
    }
  }

  return {
    isDevMode,
    enableDevMode,
    disableDevMode,
    toggleDevMode,
  }
}